export enum SpecialistActivityTypeEnum {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Offline = 'Offline',
  OnLiveChatCall = 'OnLiveChatCall',
  OnSmsInviteCall = 'OnSmsInviteCall',
}
